import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "mp_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside aria-label="Consenso cookie" data-testid="cookie-banner"
      className="fixed bottom-4 right-4 max-w-sm p-4 rounded-xl bg-[#1b0d33] border border-[#a020f0]/50 shadow-2xl text-xs z-50">
      <button data-testid="cookie-close" onClick={() => choose("dismissed")} aria-label="Chiudi"
        className="absolute top-2 right-2 text-[#94a3b8] hover:text-white">
        <X className="w-4 h-4" />
      </button>
      <p className="text-[#e2e8f0] mb-3 pr-4">
        Utilizziamo cookie tecnici per garantire l'acquisto sicuro e la migliore esperienza di navigazione.
        Dettagli nella <Link to="/cookie-policy" className="text-[#a78bfa] underline">Cookie Policy</Link>.
      </p>
      <div className="flex gap-2">
        <button data-testid="cookie-accept" onClick={() => choose("accepted")}
          className="px-4 py-1.5 rounded bg-[#a020f0] hover:brightness-110 text-white font-bold text-[11px] uppercase tracking-wider">
          Accetta
        </button>
        <button data-testid="cookie-essential" onClick={() => choose("essential-only")}
          className="px-3 py-1.5 rounded bg-[#2a164d] hover:bg-[#3b2364] text-[#cbd5e1] text-[11px]">
          Solo necessari
        </button>
      </div>
    </aside>
  );
};
